// Core
import React, { useEffect } from 'react';
import { Row, Col, Table, Spin, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

// App
import { RecordViewWrapper } from './Style';
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import {
  servicioListAction,
} from '../../../redux/administracion/servicios/actionCreator';


const ServicioViewPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.ServicioReducer.data);

  useEffect(() => {
    if (servicioListAction) {
      dispatch(servicioListAction('administracion'));
    }
  }, [dispatch]);

  const dataSource = [];

  const onHandleSearch = e => {
    dispatch(servicioListAction('administracion', e.target.value));
  };

  if (registros.length)
    registros.map((record, key) => {
      const { id, categoria, nombre } = record;
      return dataSource.push({
        key: key + 1,
        nombre,        
        categoria,        
        action: (
          <div className="table-actions">
            <Tooltip title="Editar información" color="#f8f9ac">
              <Link to={`/admin/servicios/editar/${id}`}>
                <FeatherIcon icon="dollar-sign" fill='#cccccc' />
              </Link>
            </Tooltip>  
             {/* 
            <Tool          
            <Tooltip title="Eliminar" color='#f8f9ac'>
              <Button  onClick={() => showModal(id, nombre)}>
                <FeatherIcon icon="trash" />
              </Button>
            </Tooltip> 

           tip title="Unidades médicas" color='#f8f9ac'>
              <Button  onClick={() => showModal(id, nombre)}>
                <FeatherIcon icon="box" />
              </Button>
            </Tooltip> 
           <Tooltip title="Expediente administrativo" color='#f8f9ac'>
              <Link className="edit" to={`/admin/sucursales/expediente/${id}`}>
                <FeatherIcon icon="folder" size={32} />
              </Link>
            </Tooltip>
             &nbsp;&nbsp;&nbsp;
            <Tooltip title="Bonos" color='#f8f9ac'>
              <Link className="edit" to={`/admin/sucursales/bonos/${id}`}>
                <FeatherIcon icon="gift" size={24} />
              </Link>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
            <Tooltip title="Incidencias" color='#f8f9ac'>
              <Link className="edit" to={`/admin/sucursales/incidencias/${id}`}>
                <FeatherIcon icon="meh" size={24} />
              </Link>
        </Tooltip> */}
          </div>
        ),
      });
    });

  const columns = [
    {
      title: 'Categoria',
      dataIndex: 'categoria',
      key: 'categoria',
    },   
    {
      title: 'Nombre del servicio',
      dataIndex: 'nombre',
      key: 'nombre',
    },    
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle={
          <div>
            <Button className="btn-add_new" size="default" key="1" type="primary">
              <Link to="/admin/servicios/agregar">
                <FeatherIcon icon="plus" size={14} /> <span>Agregar nuevo servicio</span>
              </Link>
            </Button>
          </div>
        }
        buttons={[
          <div key={1} className="search-box">
            <span className="search-icon">
              <FeatherIcon icon="search" size={14} />
            </span>
            <input onChange={onHandleSearch} type="text" name="recored-search" placeholder="Buscar..." />
          </div>,
        ]}
        ghost
        title='CATÁLOGO DE SERVICIOS'
      />
      <Main>
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            <Cards headless>
              {isLoading ? (
                <div className="spin">
                  <Spin />
                </div>
              ) : (
                <div>
                  <TableWrapper className="table-data-view table-responsive">
                    <Table
                      pagination={{ pageSize: 40, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>
              )}
            </Cards>
          </Col>
        </Row>
      </Main>
    </RecordViewWrapper>
  );
};

export default ServicioViewPage;
